<template>
    <structure>
        <section class="load" v-if="load"></section>
        <section class="vacancies" v-if="!load">
            <div class="title">
                <div>
                    <h1>Vagas de Emprego</h1>
                    <p>Selecione a vaga desejada para mais detalhes.</p>
                </div>
            </div>
            <div class="page-control" v-if="isPermission('job_add')">
                <div>
                    <div class="tabs">
                        <ul>
                            <li>
                                <button type="button" :class="filter === 'published' ? 'active' : ''" @click="setfilter('published')">Todos</button>
                            </li>
                            <li>
                                <button type="button" :class="filter === 'unpublished' ? 'active' : ''" @click="setfilter('unpublished')">Arquivados</button>
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-if="isPermission('job_add')">
                    <button type="button" @click="modalAdd()">Adicionar vaga <i class="fal fa-plus"></i></button>
                </div>
            </div>
            <section class="list">
                <ui-job-card v-for="(job, index) in jobs" :key="job.id" :data="job" :index="index"/>
            </section>
            <ui-no-result v-if="!total && !load" text="Nenhuma vaga encontrada." />
        </section>
        <ui-modal-add :register="register" />
        <ui-modal-delete />
        <ui-modal-candidates :register="register" />
        <ui-modal-status :register="register" />
    </structure>
</template>

<script>
    import structure from '@/templates/private'
    import uiModalAdd from './modal-add'
    import uiModalDelete from './modal-delete'
    import uiModalCandidates from './modal-candidates'
    import uiModalStatus from './modal-status'
    import { uiJobCard, uiNoResult } from '@/components'
    import { jobs } from '@/services'
    import permissions from '@/mixins/permissions'
    export default {
        name: 'jobList',
        components: { structure, uiJobCard, uiModalAdd, uiModalDelete, uiModalCandidates, uiModalStatus, uiNoResult },
        mixins: [permissions],
        data() {
            return {
                jobs: [],
                load: true, 
                register: null,
                total: 0,
                page: 1,
                filter: 'published',
            }
        },
        methods: {
            modalAdd(){
                this.$root.$emit('modal', 'add-job');
                this.$root.$emit('update-register', null);
            },
            list(){
                let paramsFilter    = this.filter ? '&status=' + this.filter : ''
                let paramsPage      =  '?page=' + this.page
                let params          = paramsPage + paramsFilter
                jobs.list(params).then( response => {
                    this.jobs = response.data.rows
                    this.total = response.data.total
                    this.load = false
                }, error => {
                    console.log(error.response.data.message)
                })
            },
            setfilter(status){
                this.filter = status
                this.load = true
                this.tickets = []
                this.page = 1
                this.list()
            },
        },
        created(){
            this.list()
            this.$root.$on("remove-item", (index) => {
                this.$delete(this.jobs, index)
            })

            this.$root.$on("add-item", (row) => {
                this.jobs.unshift(row)
            })

            this.$root.$on("update-item", (row) => {
                this.$set(this.jobs, row.index, row)
            })

            this.$root.$on("update-status", (row) => {
                this.$delete(this.jobs, row.index)
                if(this.total === 1) this.total = 0
            })

            this.$root.$on("update-register", data => {
                this.register = data
            })
        }
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
